export default __webpack_public_path__ + "static/creative-1923c2d5087952320da6fc45caa38e10.png";